export enum invitationTypes {
  FETCH_INVITATIONS_REQUEST = "FETCH_INVITATIONS_REQUEST",
  FETCH_INVITATIONS_SUCCESS = "FETCH_INVITATIONS_SUCCESS",
  FETCH_INVITATIONS_FAILURE = "FETCH_INVITATIONS_FAILURE",
}